module.exports = __webpack_public_path__ + "static/media/eye-icon.6f5b7c6d.svg";